/**
 * @file The clone action
 * @author Tzi Yang Lum
 */
import * as tslib_1 from "tslib";
import { ActionBase } from '../action';
import { DataType } from 'breeze-client';
import { OpenOverlayAction } from './open-overlay.action';
import { DoMethodAction } from './do-method-action';
var CanCloneAction = /** @class */ (function (_super) {
    tslib_1.__extends(CanCloneAction, _super);
    /**
     * @param {AlertsService} alertsService
     * @param {TranslateService} translateService
     */
    function CanCloneAction(alertsService, translateService, overlayService, domainService, eventsService) {
        var _this = _super.call(this, 'sym-icon-clone', 'APP.LISTS.CLONE') || this;
        _this.alertsService = alertsService;
        _this.translateService = translateService;
        _this.overlayService = overlayService;
        _this.domainService = domainService;
        _this.eventsService = eventsService;
        /**
         * The success labelkey
         */
        _this.successLabelKey = 'APP.LISTS.ITEMS_SUCCESSFULLY_CLONED';
        return _this;
    }
    /**
     * Execute the action
     * @param {ActionInput} input The action configuration
     */
    CanCloneAction.prototype.do = function (input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var method, configuration, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        method = input.actionConfiguration.method;
                        configuration = input.actionConfiguration.configuration;
                        if (!method) return [3 /*break*/, 2];
                        // #2188
                        if (input.item.entityType.shortName === 'Task' && input.item['Project_Oid']) {
                            return [2 /*return*/, Promise.reject({ labelKey: 'APP.SOCIAL.TASK_HAS_PROJECT' })];
                        }
                        return [4 /*yield*/, this.doMethod(input)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        if (!configuration) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.openOverlay(input)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4: return [4 /*yield*/, this.cloneSelected(input)];
                    case 5: return [2 /*return*/, _a.sent()];
                    case 6:
                        error_1 = _a.sent();
                        return [2 /*return*/, Promise.reject({ labelKey: 'APP.LISTS.ITEMS_UNSUCCESSFULLY_CLONED' })];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    CanCloneAction.prototype.isDisabled = function () {
        return false;
    };
    /**
     * Clone selected items
     * @param {ActionInput} input
     */
    CanCloneAction.prototype.cloneSelected = function (input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var listBase, fields, candidateField, found, error_2;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        listBase = input.listBase;
                        fields = listBase.configuration.data.fields;
                        found = fields.find(function (item) { return item.name.toLowerCase() === 'name'; });
                        if (found) {
                            candidateField = listBase.entityType.getDataProperty(found.name);
                        }
                        else {
                            found = fields.find(function (item) {
                                if (item.name.toLowerCase() === 'color') {
                                    return false;
                                }
                                candidateField = listBase.entityType.getDataProperty(item.name);
                                if (candidateField &&
                                    candidateField.dataType === DataType.String &&
                                    (candidateField.maxLength == null || candidateField.maxLength > 9)) {
                                    return true;
                                }
                                return false;
                            });
                        }
                        if (!found) {
                            // Nog wel info hierover maar niet verplicht meer.
                            this.alertsService.createAlert('info', 'APP.LISTS.NO_SUITABLE_FIELD_FOR_NAME');
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        listBase.selected.forEach(function (item) {
                            var copy = input.breezeService.copy(item);
                            if (found) {
                                copy[candidateField.name] =
                                    _this.translateService.instant('APP.CORE.COPY_OF') +
                                        ' ' +
                                        copy[candidateField.name];
                                // Limit maxLength if given
                                if (candidateField &&
                                    candidateField.maxLength &&
                                    copy[candidateField.name].length > candidateField.maxLength) {
                                    copy[candidateField.name] = copy[candidateField.name].substring(0, candidateField.maxLength);
                                }
                            }
                        });
                        return [4 /*yield*/, this.save(input.breezeService)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve(this.successLabelKey)];
                    case 3:
                        error_2 = _a.sent();
                        return [2 /*return*/, Promise.reject(error_2)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CanCloneAction.prototype.doMethod = function (input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new DoMethodAction(this.domainService, this.eventsService, this.getIcon(), this.getLabelKey()).do(input)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve(this.successLabelKey)];
                }
            });
        });
    };
    CanCloneAction.prototype.openOverlay = function (input) {
        return new OpenOverlayAction(this.overlayService, this.getIcon(), this.getLabelKey()).do(input);
    };
    return CanCloneAction;
}(ActionBase));
export { CanCloneAction };
